import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/H5",
    name: "H5",
    component: () =>
      import(/* webpackChunkName: "H5" */ "../views/H5/index.vue"),
  },
  // {
  //   path: "/web",
  //   name: "web",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "Web" */ "../views/Web/index.vue"),
  // },
  {
    path: "/protocol",
    name: "protocol",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/protocol/index.vue"),
  },
  {
    path: "/recharge",
    name: "recharge",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/recharge/index.vue"),
  },
  // {
  //   path: "/game",
  //   name: "game",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "Web" */ "../views/game/index.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_PATH),
  routes,
});

export default router;
